<div
  [ngClass]="{
    'bg-success text-success': badge().colour === 'green',
    'bg-danger text-danger': badge().colour === 'red',
    'bg-warning text-warning': badge().colour === 'orange',
    'bg-info text-info': badge().colour === 'blue',
    'bg-gray text-body': badge().colour === 'gray',
  }"
  class="badge larger">
  {{ badge().label }}
</div>
